module.exports = __webpack_public_path__ + "img/x20.ad86c709.jpg";